export default __webpack_public_path__ + "static/media/landing_intro.63e26bdc.mp4";